import {Page, PageContent} from 'components/Page'
import {styled} from 'common'
import {Fab, Link, Tab, Tabs, Typography} from '@mui/material'
import AddIcon from '@mui/icons-material/Add'
import useDance from 'logic/Dance/useDance.js'
import AddMediaDialog from 'components/Dance/AddMediaDialog.js'
import {Colors, Images} from 'appearance/index.js'
import VideocamIcon from '@mui/icons-material/Videocam'
import KeyboardVoiceIcon from '@mui/icons-material/KeyboardVoice'
import HourglassEmptyIcon from '@mui/icons-material/HourglassEmpty'
import {MEDIA_TYPES, ROKDIM_DANCE_URL, SUGGESTS_BY_ME} from 'constants/dance.js'
import MediaCard from 'components/Media/MediaCard.js'

const Dance = () => {
    const {
        dance,
        addMediaText,
        choreographersText,
        isRtl,
        open,
        activeTab,
        audioText,
        videoText,
        waitingForApprovalText,
        rokdimLinkText,
        addMediaForLoggedUsersText,
        composersText,
        lyricistsText,
        isLoggedIn,
        handleTabChange,
        handleOpen,
        handleClose,
        handleIsMainClick,
    } = useDance()

    if (!dance) {
        return (
            <Page>
                <DanceContainer>
                    <div>Dance not found</div>
                </DanceContainer>
            </Page>
        )
    }

    const {name, creators, media, song, rokdimId} = dance
    const {lyricist, composer} = song

    return (
        <Page>
            <DanceContainer>
                <Title variant="h3">{name}</Title>
                <CreditsContainer>
                    <InfoContainer>
                        <SubHeader variant="h6">{lyricistsText}</SubHeader>
                        <Text variant="subtitle1">{lyricist}</Text>
                    </InfoContainer>
                    <InfoContainer>
                        <SubHeader variant="h6">{composersText}</SubHeader>
                        <Text variant="subtitle1">{composer}</Text>
                    </InfoContainer>
                    <InfoContainer>
                        <SubHeader variant="h6">{choreographersText}</SubHeader>
                        <div>
                            {creators.map(
                                ({fullName, firstName, _id}, index) => (
                                    <Text
                                        key={_id}
                                        variant="subtitle1"
                                        display="inline-block">
                                        {index > 0 && ', '}
                                        {fullName || firstName}
                                    </Text>
                                )
                            )}
                        </div>
                    </InfoContainer>
                </CreditsContainer>
                {rokdimId && (
                    <RokdimLink
                        href={`${ROKDIM_DANCE_URL}/${rokdimId}`}
                        target="_blank"
                        rel="noopener noreferrer">
                        <RokdimLogo src={Images.ROKDIM_LOGO} alt="" />
                        {rokdimLinkText}
                    </RokdimLink>
                )}

                <StyledTabs value={activeTab} onChange={handleTabChange}>
                    <StyledTab
                        label={videoText}
                        icon={<VideocamIcon />}
                        value={MEDIA_TYPES.video}
                    />
                    <StyledTab
                        label={audioText}
                        icon={<KeyboardVoiceIcon />}
                        value={MEDIA_TYPES.song}
                    />
                    <StyledTab
                        label={waitingForApprovalText}
                        icon={<HourglassEmptyIcon />}
                        value={SUGGESTS_BY_ME}
                    />
                </StyledTabs>
                <MediaCardsContainer>
                    {media.map(({url, _id, name}, index) => (
                        <MediaCard
                            key={_id}
                            name={name}
                            url={url}
                            isMain={index === dance.mainMediaIndex}
                            _id={_id}
                            onClick={handleIsMainClick}
                        />
                    ))}
                </MediaCardsContainer>
                <AddMediaContainer isRtl={isRtl}>
                    {isLoggedIn ? (
                        <Fab
                            color="primary"
                            variant="extended"
                            onClick={handleOpen}>
                            <Text variant="subtitle2">{addMediaText}</Text>
                            <AddIcon sx={{m: 1}} />
                        </Fab>
                    ) : (
                        <Fab
                            disabled
                            color="primary"
                            variant="extended"
                            onClick={handleOpen}>
                            <Text variant="subtitle2">
                                {addMediaForLoggedUsersText}
                            </Text>
                            <AddIcon sx={{m: 1}} />
                        </Fab>
                    )}
                </AddMediaContainer>
                <AddMediaDialog open={open} handleClose={handleClose} />
            </DanceContainer>
        </Page>
    )
}

export default styled(Dance)``

const DanceContainer = styled(PageContent)``

const AddMediaContainer = styled.div`
    ${(props) => (props.isRtl ? 'right: 100px;' : 'left: 100px;')}
    bottom: 80px;
    position: absolute;
`

const InfoContainer = styled.div`
    display: flex;
    flex-direction: column;
`
const MediaCardsContainer = styled.div`
    display: flex;
    flex-wrap: wrap;
    gap: 30px;
    margin-top: 35px;
`

const StyledTabs = styled(Tabs)`
    && {
        margin-top: 22px;
    }
`

const StyledTab = styled(Tab)`
    && {
        /* min-width: 150px; */
    }
`
const Title = styled(Typography)`
    font-weight: bold;
    margin-bottom: 20px;
    line-height: 1.5;
    color: ${Colors.DARK_BLUE};
    width: 100%;
    text-align: center;
`

const SubHeader = styled(Typography)`
    font-weight: 600;
    color: gray;
`

const Text = styled(Typography)``

const RokdimLink = styled(Link)`
    && {
        display: inline-flex;
        align-items: center;
        gap: 8px;
        margin-top: 16px;
    }
`

const RokdimLogo = styled.img`
    height: 32px;
`

const CreditsContainer = styled.div`
    display: flex;
    flex-direction: row;
    gap: 100px;
`
